import { useState } from 'react';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [showAllPhotos, setShowAllPhotos] = useState(false);

  const galleryImages = [
    {
      src: 'https://public.readdy.ai/ai/img_res/04bbbd34525d1ad42cfe66fbd4d56e2b.jpg',
      alt: '軟式飛盤課程',
      title: '軟式飛盤課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20conducting%20science%20experiments%20in%20summer%20camp%20laboratory%2C%20children%20wearing%20safety%20goggles%20doing%20chemistry%20experiments%2C%20educational%20STEM%20activities%2C%20hands-on%20learning%2C%20colorful%20reactions%20and%20discoveries&width=400&height=300&seq=camp-science&orientation=landscape',
      alt: '科學實驗課程',
      title: '科學實驗課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20baking%20cookies%20and%20cakes%20in%20camp%20kitchen%2C%20kids%20wearing%20aprons%20learning%20cooking%20skills%2C%20summer%20camp%20culinary%20activities%2C%20hands-on%20baking%20experience%2C%20creative%20food%20preparation&width=400&height=300&seq=camp-baking&orientation=landscape',
      alt: '點心烘焙課程',
      title: '點心烘焙課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20learning%203D%20printing%20in%20summer%20camp%2C%20children%20designing%20and%20creating%203D%20models%2C%20technology%20education%2C%20STEM%20learning%20activities%2C%20modern%20educational%20equipment%2C%20creative%20digital%20design&width=400&height=300&seq=camp-3dprint&orientation=landscape',
      alt: '3D列印課程',
      title: '3D列印課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20playing%20basketball%20in%20summer%20camp%2C%20kids%20practicing%20basketball%20skills%20with%20coach%2C%20team%20sports%20training%2C%20athletic%20development%2C%20indoor%20sports%20facility%2C%20competitive%20spirit&width=400&height=300&seq=camp-basketball&orientation=landscape',
      alt: '競技籃球課程',
      title: '競技籃球課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20learning%20English%20through%20games%20in%20summer%20camp%2C%20children%20singing%20English%20songs%20and%20playing%20language%20games%2C%20interactive%20education%2C%20fun%20learning%20environment%2C%20multicultural%20activities&width=400&height=300&seq=camp-english&orientation=landscape',
      alt: '英文課程',
      title: '英文課程'
    }
  ];

  const allPhotos = [
    ...galleryImages,
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20playing%20dodgeball%20in%20summer%20camp%20gymnasium%2C%20kids%20learning%20teamwork%20and%20sports%20skills%2C%20active%20physical%20education%2C%20energetic%20group%20activity%2C%20indoor%20sports%20training&width=400&height=300&seq=camp-dodgeball&orientation=landscape',
      alt: '躲避球課程',
      title: '躲避球課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20learning%20laser%20engraving%20in%20summer%20camp%2C%20children%20creating%20personalized%20crafts%20with%20laser%20cutter%2C%20technology%20education%2C%20creative%20design%20activities%2C%20modern%20maker%20space&width=400&height=300&seq=camp-laser&orientation=landscape',
      alt: '雷射雕刻課程',
      title: '雷射雕刻課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20playing%20badminton%20in%20summer%20camp%2C%20kids%20learning%20badminton%20techniques%20with%20coach%2C%20racket%20sports%20training%2C%20athletic%20skills%20development%2C%20indoor%20sports%20activity&width=400&height=300&seq=camp-badminton&orientation=landscape',
      alt: '羽毛球課程',
      title: '羽毛球課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20learning%20mathematics%20in%20summer%20camp%20classroom%2C%20children%20solving%20math%20problems%20with%20teacher%2C%20educational%20activities%2C%20interactive%20learning%2C%20fun%20math%20games%20and%20exercises&width=400&height=300&seq=camp-math&orientation=landscape',
      alt: '數學課程',
      title: '數學課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20learning%20broadcasting%20skills%20in%20summer%20camp%2C%20kids%20using%20microphones%20and%20recording%20equipment%2C%20media%20education%2C%20public%20speaking%20training%2C%20creative%20communication%20activities&width=400&height=300&seq=camp-broadcast&orientation=landscape',
      alt: '小小廣播課程',
      title: '小小廣播課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20playing%20with%20remote%20control%20cars%20in%20summer%20camp%2C%20children%20racing%20RC%20vehicles%2C%20technology%20and%20engineering%20activities%2C%20hands-on%20learning%2C%20exciting%20outdoor%20competition&width=400&height=300&seq=camp-rccar&orientation=landscape',
      alt: '遙控賽車課程',
      title: '遙控賽車課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20swimming%20in%20summer%20camp%20pool%2C%20kids%20learning%20swimming%20techniques%20with%20instructor%2C%20water%20safety%20education%2C%20aquatic%20sports%20training%2C%20fun%20pool%20activities&width=400&height=300&seq=camp-swim&orientation=landscape',
      alt: '游泳課程',
      title: '游泳課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20learning%20street%20dance%20in%20summer%20camp%20studio%2C%20children%20practicing%20hip%20hop%20dance%20moves%2C%20energetic%20dance%20class%2C%20creative%20movement%2C%20fun%20choreography%20training&width=400&height=300&seq=camp-dance&orientation=landscape',
      alt: '流行街舞課程',
      title: '流行街舞課程'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20doing%20diamond%20painting%20in%20summer%20camp%2C%20kids%20creating%20colorful%20mosaic%20art%2C%20creative%20craft%20activities%2C%20hands-on%20artistic%20expression%2C%20detailed%20artwork%20creation&width=400&height=300&seq=camp-diamond&orientation=landscape',
      alt: '鑽石貼畫活動',
      title: '鑽石貼畫活動'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20playing%20baseball%20in%20summer%20camp%20field%2C%20children%20learning%20baseball%20skills%20with%20coach%2C%20team%20sports%20training%2C%20outdoor%20athletic%20activities%2C%20fun%20ball%20games&width=400&height=300&seq=camp-baseball&orientation=landscape',
      alt: '樂樂棒球活動',
      title: '樂樂棒球活動'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Children%20doing%20speed%20stacking%20cups%20in%20summer%20camp%2C%20kids%20practicing%20cup%20stacking%20competition%2C%20hand-eye%20coordination%20training%2C%20exciting%20challenge%20activities%2C%20competitive%20sports&width=400&height=300&seq=camp-cups&orientation=landscape',
      alt: '疊杯疊疊樂活動',
      title: '疊杯疊疊樂活動'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kids%20painting%20on%20canvas%20in%20summer%20camp%20art%20studio%2C%20children%20creating%20colorful%20oil%20paintings%2C%20artistic%20education%2C%20creative%20expression%2C%20hands-on%20art%20activities&width=400&height=300&seq=camp-painting&orientation=landscape',
      alt: '兒童油畫活動',
      title: '兒童油畫活動'
    }
  ];

  const openModal = (imageSrc: string) => {
    setSelectedImage(imageSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleShowMore = () => {
    setShowAllPhotos(true);
  };

  const displayImages = showAllPhotos ? allPhotos : galleryImages;

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            活動花絮
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            看看我們CMAP運動健康品格寒假營隊的精彩瞬間，每一張照片都記錄著孩子們在各種課程中的成長與歡樂
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayImages.map((image, index) => (
            <div 
              key={index} 
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => openModal(image.src)}
            >
              <img 
                src={image.src}
                alt={image.alt}
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center text-white">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-zoom-in-line text-2xl"></i>
                  </div>
                  <h4 className="text-lg font-semibold">{image.title}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>

        {!showAllPhotos && (
          <div className="text-center mt-12">
            <button 
              onClick={handleShowMore}
              className="bg-emerald-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多營隊照片
            </button>
          </div>
        )}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <img 
              src={selectedImage}
              alt="放大檢視"
              className="max-w-full max-h-full object-contain rounded-lg"
            />
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-white hover:text-gray-300 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-close-line text-2xl"></i>
              </div>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;